import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, LogOut } from "@/lib/icons";
import { NAV_ITEMS } from "@/components/header/NavParts";
import { AccountSwitcher } from "@/components/header/AccountSwitcher";

export function MobileMenu({ user, onLogout }) {
  const [open, setOpen] = useState(false);
  const items = NAV_ITEMS.filter((n) => n.roles.includes(user.role) || (n.to === "/clinician" && user.is_coach));
  return (
    <div className="md:hidden">
      <button data-testid="mobile-menu-btn" onClick={() => setOpen((o) => !o)} aria-label="Menu"
        className="w-10 h-10 rounded-full bg-stone-900 text-white flex items-center justify-center">
        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>
      {open && (
        <div className="fixed inset-x-0 top-[64px] bottom-0 z-50 bg-stone-900/30 backdrop-blur-sm" onClick={() => setOpen(false)}>
          <nav className="bg-paper rounded-b-3xl shadow-2xl p-4 space-y-1" data-testid="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div className="px-1 py-1"><AccountSwitcher user={user} compact /></div>
            {items.map((n) => (
              <Link key={n.to} to={n.to} data-testid={`mobile-${n.testid}`} onClick={() => setOpen(false)}
                className="block px-3 py-3 rounded-2xl text-base font-medium text-stone-800 hover:bg-amber-50">{n.label}</Link>
            ))}
            {user.is_admin && (
              <Link to="/admin/beta" data-testid="mobile-nav-beta-board" onClick={() => setOpen(false)} className="block px-3 py-3 rounded-2xl text-base font-semibold text-emerald-800 hover:bg-emerald-50">Beta board</Link>
            )}
            <button data-testid="mobile-logout-btn" onClick={() => { setOpen(false); onLogout(); }}
              className="w-full mt-2 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full text-base font-bold bg-stone-900 text-white">
              <LogOut className="w-4 h-4" /> Sign out
            </button>
          </nav>
        </div>
      )}
    </div>
  );
}
